export class ShipmentDeskDelivery {
  floor: string
  building: string
  department: string

  constructor(floor: string, building: string, department: string) {
    this.floor = floor
    this.building = building
    this.department = department
  }
}
